import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Modal,
} from "@mui/material";
import React, { useState } from "react";
import { Student } from "types/Student";
import { useUpdateStudentAggregateMutation } from "state/api";

interface FormState {
  eyeContact: boolean;
  digitalSpaceConfidence: boolean;
  electronicDeviceNavigation: boolean;
  focused: boolean;
  excitedAndHappy: boolean;
}

interface ObservationModalProps {
  open: boolean;
  onClose: () => void;
  onSubmitSuccess: () => void;
  student: Student | null;
}

const ModalStyle = {
  position: "absolute",
  top: "35%",
  left: "30%",
  width: 600,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const ObservationModal = ({
  open,
  onClose,
  onSubmitSuccess,
  student,
}: ObservationModalProps) => {
  const [formState, setFormState] = useState<FormState>({
    eyeContact: false,
    digitalSpaceConfidence: false,
    electronicDeviceNavigation: false,
    focused: false,
    excitedAndHappy: false,
  });

  const [updateStudentAggregate] = useUpdateStudentAggregateMutation();

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormState({
      ...formState,
      [event.target.name]: event.target.checked,
    });
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    try {
      // TODO: Implement API call to submit observation
      alert("Observation submitted!");
      if (student && student.aggregateData && student.aggregateData[0]) {
        const updatedAggregateData = {
          ...student.aggregateData[0],
          observation: formState,
        };
        await updateStudentAggregate({
          studentId: student.id,
          aggregateData: updatedAggregateData,
        });
      }
      onClose();
      onSubmitSuccess();
    } catch (error) {
      console.error("Error submitting observation to the backend: ", error);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="Observation"
      aria-describedby="Modal to submit the observation of the child's behavior during the test."
    >
      <Box sx={ModalStyle}>
        <form onSubmit={handleSubmit}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formState.eyeContact}
                  onChange={handleCheckboxChange}
                  name="eyeContact"
                />
              }
              label="Maintains eye contact and communicates confidently."
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formState.digitalSpaceConfidence}
                  onChange={handleCheckboxChange}
                  name="digitalSpaceConfidence"
                />
              }
              label="Displays confidence while navigating digital space."
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formState.electronicDeviceNavigation}
                  onChange={handleCheckboxChange}
                  name="electronicDeviceNavigation"
                />
              }
              label="Easily navigates through the game on the electronic device."
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formState.focused}
                  onChange={handleCheckboxChange}
                  name="focused"
                />
              }
              label="Maintains focus while playing the game and  can follow on-screen instructions."
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formState.excitedAndHappy}
                  onChange={handleCheckboxChange}
                  name="excitedAndHappy"
                />
              }
              label="Happy and excited to play the game."
            />
          </FormGroup>
          <Button type="submit" variant="contained" color="primary">
            Submit
          </Button>
        </form>
      </Box>
    </Modal>
  );
};

export default ObservationModal;
